import { subscribeShow } from "./subscribe";
import { validateFields } from "./form/fields-validator";
import { showLoader, hideLoader } from "./loader";
import {
  CONTENT_EVENT,
  NEWSLETTER_POPUP_FORM_NAME,
  pushEvent,
} from "../../../frontend/www-static/javascript/es6/form-analytics";

function initSubscribeForm() {
  const form = document.querySelector(".b-subscribe_modal-form");
  if (!form) return;

  const dismissButton = form.querySelector(".js-error-dismiss");
  dismissButton?.addEventListener("click", () => form.classList.remove("m-error"));

  const inputFields = Array.from(form.elements).filter(
    (el) => ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName) && el.name,
  );

  inputFields.forEach((field) => {
    if (field.type === "checkbox") {
      field.addEventListener("change", () => validateFields([field]));
    } else {
      field.addEventListener("blur", () => validateFields([field]));
      field.addEventListener("input", () => {
        const formField = field.closest(".js-form_field");
        if (formField?.classList.contains("m-invalid")) validateFields([field]);
      });
    }
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    if (validateFields(inputFields)) {
      form.querySelector(".js-form_field.m-invalid")?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    form.classList.remove("m-success", "m-error");
    showLoader(form);

    grecaptcha.ready(() => {
      grecaptcha.execute(window.jxRecaptchaSiteKey, { action: "subscribe" }).then(async (token) => {
        try {
          const formData = new FormData(form);
          formData.append("token", token);

          const response = await fetch(form.action, { method: "POST", body: formData });
          if (!response.ok) throw new Error();
          form.classList.add("m-success");
          pushEvent(CONTENT_EVENT, NEWSLETTER_POPUP_FORM_NAME);
          setTimeout(() => form.classList.remove("m-success"), 8000);
          form.reset();
        } catch {
          form.classList.add("m-error");
        } finally {
          hideLoader(form);
        }
      });
    });
  });
}

window.addEventListener("load", function () {
  subscribeShow();
  initSubscribeForm();
});
